var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrinter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/printer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "printer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.83398 5.16634H11.1673V3.83301C11.1673 2.49967 10.6673 1.83301 9.16732 1.83301H6.83398C5.33398 1.83301 4.83398 2.49967 4.83398 3.83301V5.16634Z",
    stroke: "#4037acd6",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.6673 10.5V13.1667C10.6673 14.5 10.0007 15.1667 8.66732 15.1667H7.33398C6.00065 15.1667 5.33398 14.5 5.33398 13.1667V10.5H10.6673Z",
    stroke: "#4037acd6",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M14 7.16699V10.5003C14 11.8337 13.3333 12.5003 12 12.5003H10.6667V10.5003H5.33333V12.5003H4C2.66667 12.5003 2 11.8337 2 10.5003V7.16699C2 5.83366 2.66667 5.16699 4 5.16699H12C13.3333 5.16699 14 5.83366 14 7.16699Z",
    stroke: "#4037acd6",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M11.3327 10.5H10.526H4.66602",
    stroke: "#4037acd6",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M4.66602 7.83301H6.66602",
    stroke: "#4037acd6",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrinter);
export default __webpack_public_path__ + "static/media/printer.a0087404f4693b49f154410bd7f8af63.svg";
export { ForwardRef as ReactComponent };